// extracted by mini-css-extract-plugin
export default {"tab":"FilterTab_tab__3PMP+","tabs":"FilterTab_tabs__GbjK4"};